import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/tools/ideal-weight/page-client.tsx");
